module.exports = __webpack_public_path__ + "static/media/dean.b8046fbe.svg";